module.exports = "/images/vendor/flag-icon-css/flags/1x1/ug.svg?6d6f88960e155a85c6e58fb0cf4681ed";